import urlJoin from 'url-join';

export enum ApiService {
  MAKGEOLLI = 'makgeolli',
  REPORT = 'report',
  USER = 'user',
  MOJITO = 'mojito',
  ZEPHYR = 'zephyr',
  GIN = 'gin',
  SOLSTICE = 'solstice',
  LEMONADE = 'lemonade',
  PAOLYTA = 'paolyta',
}

export enum ApiVersion {
  V1 = 'v1',
  V2 = 'v2',
  V3 = 'v3',
  V4 = 'v4',
  V5 = 'v5',
  V6 = 'v6',
  V7 = 'v7',
  V8 = 'v8',
  V9 = 'v9',
  V10 = 'v10',
  V11 = 'v11',
}

export enum ApiMethod {
  POST = 'POST',
  GET = 'GET',
  PATCH = 'PATCH',
  DELETE = 'DELETE',
  PUT = 'PUT',
}

export const buildUrl = ({ service, version, path }: { service: ApiService; version: ApiVersion; path: string }) => {
  return urlJoin(process.env.NEXT_PUBLIC_BE_INGRESS_BASE_URL, service, version, path);
};

export const API_INITIAL_STATUS = {
  isLoading: false,
  isSuccess: false,
  isError: false,
};
